import React, { useState, useEffect } from 'react';
import {
  Tab, Tabs, Box, Typography, TextField, Button, Select, MenuItem, InputLabel, FormControl, Alert, Snackbar, CircularProgress, Switch, FormControlLabel,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { useAuth } from '../components/AuthContext';
import { format } from 'date-fns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { API_BASE_URL } from '../components/api.js';
dayjs.locale('pt-br');

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const initialNewEmployeeState = {
  nome_reduzido: '',
  nome_completo: '',
  funcao_id: '',
  jornada_id: '',
  escala_id: '',
  data_escala: null,
  codigo_folha: '',
  ativo: true,
  vale_transporte: '',
  gratificacao: '',
  primeiro_contrato: null,
  segundo_contrato: null,
};

function PontoFuncionarios() {
  const [tabIndex, setTabIndex] = useState(0);
  const [funcoes, setFuncoes] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [escalas, setEscalas] = useState([]);
  const [funcionariosAtivos, setFuncionariosAtivos] = useState([]);
  const [funcionariosInativos, setFuncionariosInativos] = useState([]);
  const [selectedFuncionarioId, setSelectedFuncionarioId] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [novoFuncionario, setNovoFuncionario] = useState(initialNewEmployeeState);
  const [editandoFuncionario, setEditandoFuncionario] = useState(null);
  const [selectedScaleDetails, setSelectedScaleDetails] = useState(null);

  const { authenticatedFetch, logout } = useAuth();

  const fetchFuncionariosData = async () => {
    try {
      setLoading(true);
      const response = await authenticatedFetch('' + API_BASE_URL + '/api/ponto-funcionarios-editar-preencher/', { method: 'GET' });
      if (!response.ok) throw new Error('Erro ao buscar a lista de funcionários.');
      const data = await response.json();
      setFuncionariosAtivos(data.ativos || []);
      setFuncionariosInativos(data.inativos || []);
    } catch (err) {
      if (err.message.includes('Token')) logout();
      else console.error(err);
      setFuncionariosAtivos([]);
      setFuncionariosInativos([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchFuncoesJornadasEscalas = async () => {
    try {
      const [funcoesRes, escalasRes, jornadasRes] = await Promise.all([
        authenticatedFetch('' + API_BASE_URL + '/api/ponto-funcionarios-editar-funcoes/'),
        authenticatedFetch('' + API_BASE_URL + '/api/ponto-funcionarios-editar-escalas/'),
        authenticatedFetch('' + API_BASE_URL + '/api/ponto-funcionarios-editar-jornadas/'),
      ]);

      const funcoesData = await funcoesRes.json();
      const escalasData = await escalasRes.json();
      const jornadasData = await jornadasRes.json();

      console.log('funcoesData',funcoesData)
      console.log('escalasData',escalasData)
      console.log('jornadasData',jornadasData)


      setFuncoes((funcoesData || []).map(f => ({
        ...f,
        funcao_id: f.id != null ? Number(f.id) : f.id,
        funcao_descricao: f.descricao
      })));

      setEscalas((escalasData || []).map(e => ({
        ...e,
        escala_id: e.id,
        escala_jornada: e.jornada,
      })));
      
      setJornadas((jornadasData || []).map(j => ({
        ...j,
        id: j.id != null ? Number(j.id) : j.id,
        descricao: j.nome
      })));

    } catch (error) {
      console.error("Erro ao carregar dados de funcoes, jornadas e escalas:", error);
      setFuncoes([]);
      setEscalas([]);
      setJornadas([]);
    }
  };

  useEffect(() => {
    fetchFuncoesJornadasEscalas();
    fetchFuncionariosData();
  }, []);

  // Novo useEffect para encontrar os detalhes da escala selecionada
  useEffect(() => {
    if (novoFuncionario.escala_id) {
      const selectedScale = escalas.find(e => Number(e.escala_id) === Number(novoFuncionario.escala_id));
      setSelectedScaleDetails(selectedScale);
    } else {
      setSelectedScaleDetails(null);
    }
  }, [novoFuncionario.escala_id, escalas]);

  const fetchFuncionario = async (funcionarioId) => {
    if (!funcionarioId && funcionarioId !== 0) { setEditandoFuncionario(null); return; }
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-editar-funcionario/${funcionarioId}/`, { method: 'GET' });
      if (!response.ok) throw new Error('Erro ao buscar dados do funcionário para edição.');
      const data = await response.json();
      const sanitizedData = {
        funcionarios_id: data.id ?? '',
        funcionarios_nome: data.nome ?? '',
        funcionarios_nomeCompleto: data.nome_completo ?? '',
        funcionarios_codigoFolha: data.codigo_folha ?? '',
        funcionarios_passagem: data.passagem ?? '',
        funcionarios_gratificacao_espontanea: data.gratificacao_espontanea ?? '',
        funcionarios_funcao_id: data.funcao != null ? Number(data.funcao) : '',
        funcionarios_escala: data.escala ?? '',
        funcionarios_ativo: data.ativo != null ? Boolean(data.ativo) : true,
        funcionarios_primeiro_contrato: data.primeiro_contrato ? dayjs(data.primeiro_contrato) : null,
        funcionarios_segundo_contrato: data.segundo_contrato ? dayjs(data.segundo_contrato) : null,
      };
      setEditandoFuncionario(sanitizedData);
    } catch (err) {
      console.error('Erro ao buscar funcionário:', err);
      if (err.message.includes('Token')) logout();
      setEditandoFuncionario(null);
    }
  };

  useEffect(() => {
    if (selectedFuncionarioId === '' || selectedFuncionarioId == null) {
      setEditandoFuncionario(null);
      return;
    }
    fetchFuncionario(selectedFuncionarioId);
  }, [selectedFuncionarioId]);

  const handleSnackbar = (message, severity) => setSnackbar({ open: true, message, severity });

  const handleRegisterChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === 'checkbox' ? checked : value;

    if (name === 'jornada_id') {
      // Quando a jornada muda, reset a escala
      setNovoFuncionario(prev => ({ ...prev, jornada_id: newValue, escala_id: '' }));
    } else {
      setNovoFuncionario(prev => ({ ...prev, [name]: newValue }));
    }
  };
  const handleDateChange = (name, date) => setNovoFuncionario(prev => ({ ...prev, [name]: date }));

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setEditandoFuncionario(prev => ({ ...prev, [name]: checked }));
      return;
    }
    setEditandoFuncionario(prev => ({ ...prev, [name]: value }));
  };

  const handleEditDateChange = (name, date) => {
    setEditandoFuncionario(prev => ({ ...prev, [name]: date }));
  };

  const isSelectedFuncionarioActive = () => {
    if (selectedFuncionarioId === '' || selectedFuncionarioId == null) return false;
    return funcionariosAtivos.some(func => Number(func.id) === Number(selectedFuncionarioId));
  };

  const handleSelectChange = (e) => {
    const val = e.target.value;
    setSelectedFuncionarioId(val === '' ? '' : Number(val));
  };

  const handleRegisterSubmit = async () => {
    try {
      setLoading(true);

      // --- ESTA É A PARTE QUE ESTAVA FALTANDO (LINHA 213) ---
      const dataToSave = {
        funcionarios_nome: novoFuncionario.nome_reduzido,
        funcionarios_nomeCompleto: novoFuncionario.nome_completo,
        funcionarios_ativo: novoFuncionario.ativo,
        funcionarios_escala: novoFuncionario.escala_id,
        funcionarios_funcao_id: novoFuncionario.funcao_id,
        funcionarios_data_escala: novoFuncionario.data_escala ? dayjs(novoFuncionario.data_escala).format('YYYY-MM-DD') : null,
        funcionarios_codigoFolha: novoFuncionario.codigo_folha || null,
        funcionarios_passagem: novoFuncionario.vale_transporte || null,
        funcionarios_gratificacao_espontanea: novoFuncionario.gratificacao || null,
        funcionarios_primeiro_contrato: novoFuncionario.primeiro_contrato ? dayjs(novoFuncionario.primeiro_contrato).format('YYYY-MM-DD') : null,
        funcionarios_segundo_contrato: novoFuncionario.segundo_contrato ? dayjs(novoFuncionario.segundo_contrato).format('YYYY-MM-DD') : null,
      };

      // 1. Salva o novo funcionário
      const resNovo = await authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-novo/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSave),
      });

      if (!resNovo.ok) throw new Error('Erro ao criar registro do funcionário.');
      
      const funcionarioCriado = await resNovo.json();
      const novoId = funcionarioCriado.id; 

      // 2. Popula o ponto com o NOVO endpoint
      // Verificamos se novoId existe (inclusive se for 0) e se há escala selecionada
      if (novoId !== undefined && novoId !== null && novoFuncionario.escala_id !== '' && novoFuncionario.data_escala) {
        
        const resPonto = await authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-popular-novo/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            funcionario_id: novoId,
            escala_id: novoFuncionario.escala_id,
            data_inicio: dayjs(novoFuncionario.data_escala).format('YYYY-MM-DD'),
          }),
        });

        if (!resPonto.ok) {
          console.warn('Funcionário criado, mas houve um erro ao gerar os dias no ponto.');
        }
      }

      handleSnackbar(`Funcionário '${novoFuncionario.nome_completo}' registrado com sucesso!`, 'success');
      setNovoFuncionario(initialNewEmployeeState);
      fetchFuncionariosData();
    } catch (error) {
      console.error(error);
      handleSnackbar(error.message || 'Erro ao registrar funcionário.', 'error');
    } finally {
      setLoading(false);
    }
  };

const handleEditSubmit = async () => {
  if (!editandoFuncionario) return;
  try {
    const dataToSave = {
      funcionarios_nome: editandoFuncionario.funcionarios_nome,
      funcionarios_nomeCompleto: editandoFuncionario.funcionarios_nomeCompleto,
      funcionarios_codigoFolha: editandoFuncionario.funcionarios_codigoFolha,
      funcionarios_passagem: editandoFuncionario.funcionarios_passagem ? parseFloat(String(editandoFuncionario.funcionarios_passagem).replace(',', '.')) : null,
      funcionarios_gratificacao_espontanea: editandoFuncionario.funcionarios_gratificacao_espontanea ? parseFloat(String(editandoFuncionario.funcionarios_gratificacao_espontanea).replace(',', '.')) : null,
      funcionarios_funcao_id: editandoFuncionario.funcionarios_funcao_id === '' ? null : Number(editandoFuncionario.funcionarios_funcao_id),
      funcionarios_ativo: editandoFuncionario.funcionarios_ativo,
      funcionarios_primeiro_contrato: editandoFuncionario.funcionarios_primeiro_contrato ? format(editandoFuncionario.funcionarios_primeiro_contrato.toDate(), 'yyyy-MM-dd') : null,
      funcionarios_segundo_contrato: editandoFuncionario.funcionarios_segundo_contrato ? format(editandoFuncionario.funcionarios_segundo_contrato.toDate(), 'yyyy-MM-dd') : null,
    };

    await authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-editar-salvar/${editandoFuncionario.funcionarios_id}/`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataToSave),
    });
    handleSnackbar('Alterações salvas com sucesso!', 'success');
    fetchFuncionariosData();
    fetchFuncionario(selectedFuncionarioId);
  } catch (error) {
    console.error(error);
    handleSnackbar('Erro ao salvar alterações.', 'error');
  }
};

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Box sx={{ width: '100%' }}>
        <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)} aria-label="tabs">
          <Tab label="Registrar Funcionário" />
          <Tab label="Editar Funcionário" />
        </Tabs>
        <TextField
          fullWidth
          value="Lembrar de colocar a coluna funcionarios_nome como unique"
          InputProps={{
            readOnly: true,
          }}
        />
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TabPanel value={tabIndex} index={0}>
              <Typography variant="h6" sx={{ mb: 2 }}>Registrar novo funcionário</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* Linha 1: Nome Reduzido, Função, Jornada e Ativo */}
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
                  <TextField label="Nome Reduzido" name="nome_reduzido" value={novoFuncionario.nome_reduzido} onChange={handleRegisterChange} sx={{ flex: 1 }} />
                  <FormControl sx={{ flex: 1 }}>
                    <InputLabel>Função</InputLabel>
                    <Select label="Função" name="funcao_id" value={novoFuncionario.funcao_id} onChange={handleRegisterChange}>
                      <MenuItem value=""><em>Selecione uma função</em></MenuItem>
                      {funcoes.map(funcao => (
                        <MenuItem key={funcao.funcao_id} value={funcao.funcao_id}>
                          {funcao.funcao_descricao}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ flex: 1 }}>
                    <InputLabel>Jornada</InputLabel>
                    <Select label="Jornada" name="jornada_id" value={novoFuncionario.jornada_id} onChange={handleRegisterChange}>
                      <MenuItem value=""><em>Selecione uma jornada</em></MenuItem>
                      {jornadas.map(jornada => (
                        <MenuItem key={jornada.id} value={jornada.id}>
                          {jornada.descricao}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControlLabel control={<Switch checked={novoFuncionario.ativo} onChange={handleRegisterChange} name="ativo" />} label="Ativo" sx={{ mb: 0.5 }} />
                </Box>
                {/* Linha 2: Escala, Data da Escala, Código Folha, Vale Transporte, Gratificação */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <FormControl sx={{ flex: 1 }}>
                    <InputLabel>Escala</InputLabel>
                    <Select
                      label="Escala"
                      name="escala_id"
                      value={novoFuncionario.escala_id}
                      onChange={handleRegisterChange}
                      disabled={!novoFuncionario.jornada_id}
                    >
                      <MenuItem value="">
                        <em>{novoFuncionario.jornada_id ? "Selecione uma escala" : "Selecione uma jornada primeiro"}</em>
                      </MenuItem>
                      {escalas
                        .filter(escala => Number(escala.jornada) === Number(novoFuncionario.jornada_id))
                        .map(escala => (
                          <MenuItem key={escala.escala_id} value={escala.escala_id}>
                            {`${escala.escala_id}`}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <DatePicker
                    label="Data da Escala"
                    value={novoFuncionario.data_escala}
                    onChange={(date) => handleDateChange('data_escala', date)}
                    renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                  />
                  <TextField label="Código Folha" name="codigo_folha" value={novoFuncionario.codigo_folha} onChange={handleRegisterChange} type="number" sx={{ flex: 1 }} />
                  <TextField label="Vale Transporte" name="vale_transporte" value={novoFuncionario.vale_transporte} onChange={handleRegisterChange} type="number" sx={{ flex: 1 }} />
                  <TextField label="Gratificação Espontânea" name="gratificacao" value={novoFuncionario.gratificacao} onChange={handleRegisterChange} type="number" sx={{ flex: 1 }} />
                </Box>
                {/* Linha 3: Nome Completo */}
                <Box sx={{ display: 'flex' }}>
                  <TextField label="Nome Completo" name="nome_completo" value={novoFuncionario.nome_completo} onChange={handleRegisterChange} fullWidth />
                </Box>
                {/* Linha 4: Contratos */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <DatePicker
                    label="Vencimento 1º Contrato"
                    value={novoFuncionario.primeiro_contrato}
                    onChange={(date) => handleDateChange('primeiro_contrato', date)}
                    renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                  />
                  <DatePicker
                    label="Vencimento 2º Contrato"
                    value={novoFuncionario.segundo_contrato}
                    onChange={(date) => handleDateChange('segundo_contrato', date)}
                    renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                  />
                </Box>
                {/* Linha 5: Tabela de Escala (Condicional) */}
                {selectedScaleDetails && (
                  <Box sx={{ mt: 2, width: 350}}>
                    <Typography variant="h6" gutterBottom>Detalhes da Escala</Typography>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Dia da Semana</TableCell>
                            <TableCell align="right">Entrada</TableCell>
                            <TableCell align="right">Saída</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {[
                            { dia: 'Segunda-feira', entrada: selectedScaleDetails.entrada_segunda, saida: selectedScaleDetails.saida_segunda },
                            { dia: 'Terça-feira', entrada: selectedScaleDetails.entrada_terca, saida: selectedScaleDetails.saida_terca },
                            { dia: 'Quarta-feira', entrada: selectedScaleDetails.entrada_quarta, saida: selectedScaleDetails.saida_quarta },
                            { dia: 'Quinta-feira', entrada: selectedScaleDetails.entrada_quinta, saida: selectedScaleDetails.saida_quinta },
                            { dia: 'Sexta-feira', entrada: selectedScaleDetails.entrada_sexta, saida: selectedScaleDetails.saida_sexta },
                            { dia: 'Sábado', entrada: selectedScaleDetails.entrada_sabado, saida: selectedScaleDetails.saida_sabado },
                            { dia: 'Domingo', entrada: selectedScaleDetails.entrada_domingo, saida: selectedScaleDetails.saida_domingo },
                          ].map((row) => (
                            <TableRow key={row.dia}>
                              <TableCell component="th" scope="row">{row.dia}</TableCell>
                              <TableCell align="right">{row.entrada || '-'}</TableCell>
                              <TableCell align="right">{row.saida || '-'}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
                {/* Linha 6: Botões */}
                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Button variant="contained" onClick={handleRegisterSubmit}>Salvar</Button>
                  <Button variant="outlined" onClick={() => setNovoFuncionario(initialNewEmployeeState)}>Cancelar</Button>
                </Box>
              </Box>
            </TabPanel>

            <TabPanel value={tabIndex} index={1}>
              <Typography variant="h6" sx={{ mb: 2 }}>Editar Funcionário</Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ flex: 1 }}>
                  <InputLabel>Funcionários Ativos</InputLabel>
                  <Select label="Funcionários Ativos" value={isSelectedFuncionarioActive() ? selectedFuncionarioId : ''} onChange={handleSelectChange}>
                    <MenuItem value=""><em>Nenhum</em></MenuItem>
                    {funcionariosAtivos.map(func => (
                      <MenuItem key={func.id} value={func.id}>
                        {func.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <InputLabel>Funcionários Inativos</InputLabel>
                  <Select label="Funcionários Inativos" value={!isSelectedFuncionarioActive() ? selectedFuncionarioId : ''} onChange={handleSelectChange}>
                    <MenuItem value=""><em>Nenhum</em></MenuItem>
                    {funcionariosInativos.map(func => (
                      <MenuItem key={func.id} value={func.id}>
                        {func.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {editandoFuncionario ? (
                <Box sx={{ mt: 4 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>Dados do Funcionário Selecionado</Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField label="ID" value={editandoFuncionario.funcionarios_id || ''} disabled sx={{ flex: 1 }} />
                      <TextField label="Nome Reduzido" name="funcionarios_nome" value={editandoFuncionario.funcionarios_nome || ''} onChange={handleEditChange} sx={{ flex: 1 }} />
                      <FormControlLabel
                        control={<Switch checked={!!editandoFuncionario.funcionarios_ativo} onChange={handleEditChange} name="funcionarios_ativo" />}
                        label="Ativo"
                        sx={{ mb: 0.5 }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                      <TextField label="Nome Completo" name="funcionarios_nomeCompleto" value={editandoFuncionario.funcionarios_nomeCompleto || ''} onChange={handleEditChange} fullWidth />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <FormControl sx={{ flex: 1 }}>
                        <InputLabel>Função</InputLabel>
                        <Select
                          label="Função"
                          name="funcionarios_funcao_id"
                          value={editandoFuncionario.funcionarios_funcao_id !== '' ? editandoFuncionario.funcionarios_funcao_id : ''}
                          onChange={handleEditChange}
                        >
                          <MenuItem value=""><em>Selecione uma função</em></MenuItem>
                          {funcoes.map(funcao => (
                            <MenuItem key={funcao.funcao_id} value={funcao.funcao_id}>
                              {funcao.funcao_descricao}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField label="Escala" value={editandoFuncionario.funcionarios_escala ?? ''} disabled sx={{ flex: 1 }} />
                      <TextField label="Código Folha" name="funcionarios_codigoFolha" value={editandoFuncionario.funcionarios_codigoFolha || ''} onChange={handleEditChange} type="number" sx={{ flex: 1 }} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <TextField label="Vale Transporte" name="funcionarios_passagem" value={editandoFuncionario.funcionarios_passagem || ''} onChange={handleEditChange} type="number" sx={{ flex: 1 }} />
                      <TextField label="Gratificação Espontânea" name="funcionarios_gratificacao_espontanea" value={editandoFuncionario.funcionarios_gratificacao_espontanea || ''} onChange={handleEditChange} type="number" sx={{ flex: 1 }} />
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        <DatePicker
                          label="Vencimento 1º Contrato"
                          value={editandoFuncionario.funcionarios_primeiro_contrato || null}
                          onChange={(date) => handleEditDateChange('funcionarios_primeiro_contrato', date)}
                          renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                        />
                        <DatePicker
                          label="Vencimento 2º Contrato"
                          value={editandoFuncionario.funcionarios_segundo_contrato || null}
                          onChange={(date) => handleEditDateChange('funcionarios_segundo_contrato', date)}
                          renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                        />
                      </Box>
                    </LocalizationProvider>
                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                      <Button variant="contained" onClick={handleEditSubmit}>Salvar Alterações</Button>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Alert severity="info" sx={{ mt: 4 }}>
                  Selecione um funcionário ativo ou inativo para editar.
                </Alert>
              )}
            </TabPanel>
          </>
        )}
        <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
}

export default PontoFuncionarios;